var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEver = function SvgEver(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.75,
    stroke: "#080808",
    strokeOpacity: 0.08,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7146 19.388C12.6521 19.4444 12.5897 19.5137 12.4689 19.6611C12.0858 20.1424 11.6402 21.0182 12.4689 21.8809C13.0602 22.4966 14.447 23.5067 15.7338 24.3955C17.1497 25.371 18.7738 26.4592 19.2194 26.6846C20.0815 27.1139 21.3891 27.4087 21.6973 25.4534C22.1637 22.4836 23.9669 10.0711 23.996 9.62016C24.021 9.28199 23.9294 9.05654 23.6837 9.00885C23.4755 8.96983 23.2922 9.06088 23.0799 9.26031C22.7425 9.58114 12.7479 19.3533 12.7146 19.388Z",
    fill: "#0177DC"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEver);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "EVER.ceed9a5b93ede58a381b590a38a95efa.svg";